{% block sw_product_detail_upselling %}
    <div class="sw-product-detail-upselling">
        {% block sw_product_detail_upselling_items %}
            <ul v-if="upsellings && upsellings.length > 0" class="sw-product-detail-upselling__upselling-list">
                <sw-product-upselling-form
                    v-for="item in upsellings"
                    :key="item.id"
                    :upselling="item">
                </sw-product-upselling-form>
            </ul>
        {% endblock %}

        {% block sw_product_detail_upselling_empty_state_card %}
            <mt-card
                v-else
                position-identifier="sw-product-detail-upselling-empty-state"
            >
                {% block sw_product_detail_upselling_empty_state %}
                    <sw-empty-state
                        :absolute="false"
                        empty-module
                    >
                        {% block sw_product_detail_upselling_empty_state_icon %}
                            <template #icon>
                                <img
                                    :src="assetFilter('/administration/administration/static/img/empty-states/products-empty-state.svg')"
                                    :alt="$tc('sw-product.crossselling.cardTitleCrossSelling')"
                                >
                            </template>
                        {% endblock %}

                        {% block sw_product_detail_upselling_empty_state_content_empty %}
                            <p>{{ $tc('sw-product.upselling.emptyStateDescription') }}</p>
                        {% endblock %}

                        {% block sw_product_detail_upselling_empty_state_actions %}
                            <template #actions>
                                <mt-button
                                    ghost
                                    :disabled="false"
                                    variant="secondary"
                                    @click="onAddUpselling"
                                >
                                    {{ $tc('sw-product.upselling.buttonAddUpselling') }}
                                </mt-button>
                            </template>
                        {% endblock %}
                    </sw-empty-state>
                {% endblock %}
            </mt-card>
            {% block sw_product_detail_upselling_add %}
                <mt-button
                    v-if="upsellings && upsellings.length > 0"
                    class="sw-product-detail-upselling__context-button"
                    ghost
                    variant="secondary"
                    @click="onAddUpselling"
                    :disabled="false"
                >
                    {{ $tc('sw-product.upselling.buttonAddUpselling') }}
                </mt-button>
            {% endblock %}
        {% endblock %}
    </div>
{% endblock %}
